export type ThemeClassName =
  | 'bg-page'
  | 'bg-base1'
  | 'bg-base2'
  | 'bg-interactive-emphasis-high'
  | 'bg-critical-emphasis-high'
  | 'text-neutral-primary'
  | 'text-neutral-inverse'
  | 'text-interactive';

/**
 * Utility function to help with autocompletion of class names
 */
export function cn(...args: ThemeClassName[]) {
  return args.join(' ');
}
